import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { Observable } from "rxjs";
import { HttpclientService } from "../../../shared";
import { MTAOverrideRequest } from "./MTAOverrideRequest";
import { StudentIDRequest } from "./StudentIDRequest";

@Injectable()
export class DemographicsService {
	constructor(private httpclientService: HttpclientService) {}

	DemographicGet(personID) {
		var postResult$ = new Subject();
		var url = "StudentDemographic/DemographicGet?personID=" + personID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	print(personID, schoolID) {
		var strParam = personID + "|PersonID";
		var reportFileName = "RPTStudentDemographics.rpx";
		var postResult$ = new Subject();
		var url = "Report/PrintByReportFileName?ReportFileName=" + reportFileName + "&strParam=" + strParam + "&schoolID=" + schoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ParentRelationshipList() {
		var postResult$ = new Subject();
		var url = "StudentDemographic/ParentRelationshipList";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LanguageList() {
		var postResult$ = new Subject();
		var url = "StudentDemographic/LanguageList";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GuardianDetail(personID) {
		var postResult$ = new Subject();
		var url = "StudentDemographic/GuardianDetail?personID=" + personID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GuardianSave(parent) {
		var postResult$ = new Subject();
		var url = "StudentDemographic/GuardianSave";

		var promise$ = this.httpclientService.post(url, parent);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GuardianDelete(parent_personID) {
		var postResult$ = new Subject();
		var url = "StudentDemographic/GuardianDelete?parent_personID=" + parent_personID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GetMTAPrefs(parms: StudentIDRequest) {
		var postResult$ = new Subject();
		var url = "StudentDemographic/GetMTAPrefs";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GetMTAOverrideMessage() {
		var postResult$ = new Subject();
		var url = "StudentDemographic/GetMTAOverrideMessage?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	MTAReasonGetList() {
		var postResult$ = new Subject();
		var url = "StudentDemographic/MTAReasonGetList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	MTAOverrideReasonSelect(parms: StudentIDRequest) {
		var postResult$ = new Subject();
		var url = "StudentDemographic/MTAOverrideReasonSelect";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	MTAOverrideToggle(parms: MTAOverrideRequest) {
		var postResult$ = new Subject();
		var url = "StudentDemographic/MTAOverrideToggle";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
